import { CancellationReason } from '@mews-commander/data-access';
import { LocalizedEnumify } from '@mews/framework';
import { CancellationReason as CancellationReasonEnumify } from '@mews-commander/legacy-data-structures';

interface CancellationFeeReasonProps {
    cancellationReason: CancellationReason;
}

export const CancellationFeeReason: React.FC<CancellationFeeReasonProps> = ({ cancellationReason }) => {
    const cancellationReasonEnum = CancellationReasonEnumify.getByName(cancellationReason);
    return <LocalizedEnumify enumValue={cancellationReasonEnum} />;
};
